module.exports = __webpack_public_path__ + "img/x431_icon.fc480ab0.png";